import React, { useEffect,useState} from 'react';
import { Button } from 'react-bootstrap';
//import DocumentWarehouseDatatable from './DocumentWarehouseDatatable';
import DocumentWarehouseDatatable from '../document/DocumentWarehouseDatatable';




const DocumentWarehouseListTab = (props) => {

  
  
  const [entitySubName, setEntitySubName] = useState();
  const [entitySpecify, setEntitySpecify] = useState();    

  useEffect(() => {      
    setEntitySubName(props.entitySubName);
  }, [props.entitySubName])

  const handleEntitySpecify  = (entitySpecify) => {
    setEntitySpecify(entitySpecify);                   
    props.parentCallback(entitySubName,entitySpecify,null);        
  };

  const handleCallback = (id) => {          
        props.parentCallback(entitySubName,entitySpecify,id,true);          
  };



  return (
      <div className={`tab-pane ${props.isActive ? 'active' : ''}`}>          
      
        <DocumentWarehouseDatatable           
          parentCallback={handleCallback}                
          entitySubName={entitySubName}   
          parentCallbackEntitySpecify={handleEntitySpecify}      
          checkTime={props.checkTime}
          showSelectEntitySpecify={true}       
        />  

        <Button
          bsStyle="primary"
        //  bsSize="large"
          className="ml-3 mt-3"
          onClick={() => handleCallback('')} 
        >
          <i class="fas fa-plus"></i>
        </Button>
      </div>
  );
};

export default DocumentWarehouseListTab;